import { useState } from 'react'
import { STRINGS } from '../../utils/strings'
import { CustomButton, FIELD_VALUE_CONSTANTS, FormInput, Modal } from '@ui-kit'
import { BUTTONS, componentNames } from '../../utils/constants'
import { TableViewType } from '../../types/userPreferences.types'

const SaveViewModal = ({
  modal,
  setModal,
  handleSave,
  currentView,
}: {
  modal: { type: string; state: boolean }
  setModal: React.Dispatch<
    React.SetStateAction<{
      type: string
      state: boolean
    }>
  >
  handleSave: (name: string) => Promise<void>
  currentView: TableViewType | undefined
}) => {
  const [name, setName] = useState<string>(
    modal?.type !== BUTTONS.CREATE ? currentView?.name ?? '' : ''
  )
  const handleNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setName(event?.target?.value)
  }
  return (
    <div className="modal-non-rounded">
      <Modal
        isOpen={modal.state}
        closeModal={() => setModal({ type: '', state: false })}
        bodyCssClassName={'z-[9999]'}
        cssClassName={'z-[9999]'}
        width="w-[32rem]"
        showCloseButton={false}
      >
        <div className="px-[1.125rem] py-[1rem] flex flex-col gap-3">
          <div className="flex justify-between items-center">
            <span className="flex text-md font-medium leading-[1.125rem]">
              {modal?.type === BUTTONS.SAVE_AS
                ? STRINGS.FILTER_VIEW_SAVE_AS
                : STRINGS.FILTER_VIEW_SAVE}
            </span>
            {/* buttons */}
            <div>
              <div className="flex gap-3 items-center justify-end w-full">
                <CustomButton
                  onClick={() => setModal({ type: '', state: false })}
                  color="primary"
                  className="border border-primary-500 text-xs !w-fit"
                >
                  <span className="text-xs text-accent-900 font-light">
                    {BUTTONS.CANCEL}
                  </span>
                </CustomButton>
                <CustomButton
                  onClick={() => {
                    const trimmed = name?.trim()
                    if (!trimmed) return
                    handleSave(trimmed)
                  }}
                  color="primary"
                  isFilled={true}
                  disabled={!name?.trim()}
                  className="w-fit"
                >
                  {BUTTONS.SAVE}
                </CustomButton>
              </div>
            </div>
          </div>
          <div>
            <FormInput
              name={''}
              label={componentNames.NAME}
              maxLength={FIELD_VALUE_CONSTANTS.FIFTY}
              defaultValue={name}
              onChange={handleNameChange}
              validation={{
                required: true,
              }}
            />
          </div>
          <div className="flex w-full">
            <span className="ml-auto text-xs text-accent-600">
              {STRINGS.CHARACTER_LIMIT_50}
            </span>
          </div>
        </div>
      </Modal>
    </div>
  )
}

export default SaveViewModal
